export const channels = (
  state = {
    channelIsB2b: false,
    switchChannelTypeUrl: '',
    channelsB2C: [],
    channelsB2B: [],
  }) => { return state; };
